export default  [
  {
    id: '1',
    icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRtSNQGIA1oHvu2FR-H80yoB1rAykuN5fnTbjiLnijVw&s',
    symbol: 'tUSDC',
    name: 'tUSDC',
    decimals: '9',
    address: '0x831f0a8aF16c0377558F41e64E7Db4a4777e1059',
    exchange_rate: '1.00 $',
    vesting_period: '3 Hours',
    explorer: 'https://testnet.bscscan.com/',
    network: "BSC-testnet"
  },
  {
    id: '2',
    icon: 'https://cryptologos.cc/logos/tether-usdt-logo.png',
    symbol: 'tUSDT',
    name: 'tUSDT',
    decimals: '9',
    address: '0x1b90e8d0195b005E33c2492fC53DdeD93034cA07',
    exchange_rate: '1.00 $',
    vesting_period: '6 Hours',
    explorer: 'https://testnet.bscscan.com/',
    network: "BSC-testnet"
  },
  {
    id: '3',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/200x200/1975.png',
    symbol: 'tLINK',
    name: 'tLINK',
    decimals: '9',
    address: '0xBE7cC6575298bDBD758AbfA082EE5a016E4423Df',
    exchange_rate: '0.50 $',
    vesting_period: '3 Hours',
    explorer: 'https://testnet.bscscan.com/',
    network: "BSC-testnet"
  }, 
  {
    id: '3',
    icon: 'https://img.cryptorank.io/coins/chedda_token1659624436564.png',
    symbol: 'tCHEDDA',
    name: 'tCHEDDA',
    decimals: '18',
    address: '0x58D890c0203e43946e62CbcF889B8840f63eCc6F',
    exchange_rate: '0.05 $',
    vesting_period: '6 Hours',
    explorer: 'https://testnet.bscscan.com/',
    network: "BSC-testnet"
  }, 
];
 